<div class='lyrics-box'>
    <img class="closebutton pointer m-t-5" alt="Close" (click)="closeDialog()">


   
        <h3 class="header">Lyrics</h3>
   
    <!-- <hr> -->
    <div class="content">

        <div class="row d-flex justify-content-center ">
            <p class="text ">{{data.text}}</p>


        </div>


    </div>

</div>